import React from "react";
import { pcImageUrl, pcImageFallback } from "../lib/pcImage";

function normalizeNumber(num) {
  return String(num || "").split("/")[0].trim().replace(/^0+/, "") || "0";
}

export default function MissingCardTile({ entry }) {
  return (
    <div
      data-testid={`missing-card-tile-${entry.card_number}`}
      className="group relative flex flex-col bg-[#111113] border border-white/5 rounded-xl overflow-hidden"
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-black">
        {entry.image_url ? (
          <img
            src={pcImageUrl(entry.image_url, "240")}
            alt={entry.name}
            onError={pcImageFallback}
            className="w-full h-full object-cover grayscale brightness-[0.35] transition-all duration-300 group-hover:grayscale-0 group-hover:brightness-100"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-zinc-700 text-xs">#{entry.card_number}</div>
        )}
        <span className="absolute top-2 left-2 text-[10px] uppercase tracking-widest bg-black/70 text-zinc-400 px-2 py-0.5 rounded-full">Missing</span>
      </div>
      <div className="p-3">
        <p className="text-sm font-medium truncate text-zinc-500">{entry.name}</p>
        <p className="text-xs text-zinc-600">#{entry.card_number}</p>
      </div>
    </div>
  );
}

export { normalizeNumber };
